/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred quality score (Q)`)
};

const es_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación de calidad Phred (Q)`)
};

const de_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred-Qualitätswert (Q)`)
};

const nl_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred-kwaliteitsscore (Q)`)
};

const fr_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score de qualité Phred (Q)`)
};

const it_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio di qualità Phred (Q)`)
};

const pt_br2_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escore de qualidade Phred (Q)`)
};

const pt_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação de qualidade Phred (Q)`)
};

const ja_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred品質スコア (Q)`)
};

const zh_phred_field_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred 质量分数（Q）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_field_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_field_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_field_q", locale)
	if (locale === "en") return en_phred_field_q(inputs)
	if (locale === "es") return es_phred_field_q(inputs)
	if (locale === "de") return de_phred_field_q(inputs)
	if (locale === "nl") return nl_phred_field_q(inputs)
	if (locale === "fr") return fr_phred_field_q(inputs)
	if (locale === "it") return it_phred_field_q(inputs)
	if (locale === "pt-BR") return pt_br2_phred_field_q(inputs)
	if (locale === "pt") return pt_phred_field_q(inputs)
	if (locale === "ja") return ja_phred_field_q(inputs)
	return zh_phred_field_q(inputs)
};